import MockConfig from '../../config/data/mock/index'
import GenerationMethods from "./dataGenerate"

/**
 * Description
 * @param {any} options={} Mock options
 * @returns {Promise}
 */
function _getMock(options={}) {
    const { moduleName, mockName, mockMethodName, request } = options

    return new Promise(async (resolve, reject) => {
        // Check are we have such method for data generation
        if (mockMethodName && !GenerationMethods[mockMethodName]) {
            return reject({
                message: `Mock does not have needed data generation method for this request. (Method name ${mockMethodName})`
            })
        }

        // Call data generation method and return data
        if (mockMethodName) {
            const result = await GenerationMethods[mockMethodName](request)

            return resolve(result)
        }

        const config = MockConfig[moduleName][mockName]

        // Check are we have static mokc data for this key
        if (!config) {
            return reject({
                message: `Mock does not have needed data for this request. (Request name ${mockName})`
            })
        }

        return resolve(config)
    })
}

export default function () {
    function getMock(options={}) {
        return _getMock(options)
    }

    return {
        getMock
    }
}
